import { Button, Flexer, Header, Heading, Icon, View, useVisibility } from '@fold-dev/core'
import { useEffect, useState } from 'react'
import { TbPlus } from 'react-icons/tb'
import { Outlet, useParams } from 'react-router'
import { Block, Error, Loading } from '../components'
import { Tasks } from '../components/tasks/tasks'
import { useDocumentTitle } from '../helpers'
import { NewTaskModal } from '../modals/new-task.modal'
import { useAppStore } from '../store/app'
import { MinimizeHeader } from '../components/minimize-header'

export const UpcomingLayout = (props: any) => {
    const { workspaceId } = useParams()
    const addModal = useVisibility()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<any>(null)
    const actions = useAppStore((state) => state.actions)
    const user = useAppStore((state) => state.user)

    useDocumentTitle('Upcoming')

    useEffect(() => {
        if (workspaceId) {
            actions.setFilters({ sort: null, hideComplete: false })
            actions.setProject({ id: null })
            actions.setViewType('upcoming')
        }
    }, [workspaceId])

    return (
        <>
            {addModal.visible && (
                <NewTaskModal
                    type="upcoming"
                    teamId={null}
                    onDismiss={addModal.hide}
                    defaultDate={new Date()}
                    defaultUsers={[]}
                    selectProject
                />
            )}

            <View
                row
                flex={1}
                m="0 var(--frame-padding) 0 0"
                width="100%"
                height="calc(100% - (var(--frame-padding) * 2))"
                justifyContent="flex-start"
                position="relative"
                bgToken="surface"
                style={{
                    overflow: 'hidden',
                    borderTopLeftRadius: 'var(--frame-radius)',
                    borderTopRightRadius: 'var(--frame-radius)',
                    borderBottomLeftRadius: 'var(--frame-radius)',
                    borderBottomRightRadius: 'var(--frame-radius)',
                    border: 'var(--frame-border)',
                }}>
                <View
                    column
                    flex={1}
                    height="100%"
                    width="100%"
                    position="relative"
                    justifyContent="stretch">
                    <MinimizeHeader>
                        <Heading as="h5">Upcoming</Heading>
                        <Flexer />
                        <Button
                            onClick={addModal.show}
                            size="sm"
                            prefix={<Icon icon={TbPlus} />}>
                            Add Task
                        </Button>
                    </MinimizeHeader>
                    {/*  <Header
                        row
                        border="none"
                        gap="0rem"
                        p="0rem 2rem"
                        height="5rem"
                        m="-1rem 0 0 0"
                        justifyContent="flex-start">
                        <Block
                            name="Upcoming"
                            color="var(--f-color-accent)"
                            icon="main:upcoming"
                            size="xl"
                            inProjectLayout
                        />

                        <Heading
                            as="h3"
                            className="main-heading">
                            Upcoming
                        </Heading>

                        <Flexer />


                        <Button
                            onClick={addModal.show}
                            m="0 0 0 1rem"
                            height="2.25rem"
                            variant="accent"
                            prefix={<Icon icon={TbPlus} />}>
                            Add Task
                        </Button>
                    </Header>
 */}
                    <View
                        column
                        flex={1}
                        width="100%"
                        height="100%"
                        position="relative"
                        justifyContent="stretch">
                        <Error error={error} />
                        <View
                            width="100%"
                            height="100%"
                            style={{ top: 0, left: 0, paddingTop: '2rem' }}
                            bgToken="surface"
                            position="absolute"
                            className="f-overflow-y-auto upcoming">
                            <Tasks
                                view="list"
                                workspaceId={workspaceId}
                                projectId={null}
                                teamId={null}
                                type="upcoming"
                            />
                        </View>
                    </View>
                </View>
            </View>

            <Outlet />
        </>
    )
}
